import { render, staticRenderFns } from "./update-admin.vue?vue&type=template&id=306a12f8&scoped=true"
import script from "./update-admin.vue?vue&type=script&lang=js"
export * from "./update-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306a12f8",
  null
  
)

export default component.exports